<template>
  <VDataGridV2
    :loader="dataLoader"
    :context-menu="ProductsService.contextMenu"
    sticky
    clickable
    paginated
    entity-type="product"
    @row:dblclick="openCard"
  >
    <VDataGridColumnV2
      id="id"
      content-align="left"
      label="№"
      width="50px"
    >
      <template #default="{ row }">
        <VLink
          @click="openCard(row)"
        >
          {{ row.id }}
        </VLink>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="code"
      width="100px"
      content-align="left"
      label="Арт"
      filterable
      :filter-props="{
        placeholder: 'Введите артикул',
        clearable:   true,
      }"
    >
      <template #default="{ row }">
        {{ row.code || '--' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="name"
      label="Название"
      content-class="ellipsis"
      width="400px"
      filterable
      filter-send-name="pattern"
      :filter-props="{
        placeholder: 'Введите наименование продукта',
        clearable:   true,
      }"
    >
      <template #default="{ row }">
        <div
          class="ellipsis"
          :title="row.name"
        >
          {{ row.name }}
        </div>
        <div
          class="description"
          :title="row.description"
        >
          {{ row.description }}
        </div>

        <VBadges>
          <VBadge
            v-if="row?.isCreatedImplicitly"
            @mouseenter="$core.tooltip.show($event.currentTarget, 'Создан неявно')"
            @mouseleave="$core.tooltip.hide()"
          >
            Новый
          </VBadge>
        </VBadges>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="type"
      label="Категория"
      width="150px"
      filterable
      filter-type="select"
      filter-send-name="isAssigned"
      :filter-props="{
        clearable:   true,
         placeholder: 'Все',
         options: [
           { id: true,  name: 'Распределённые' },
           { id: false, name: 'Не распределённые' },
         ],
      }"
      content-align="center"
    >
      <template #default="{ row }">
        {{ row.category ? 'Распределённый' : 'Не распределённый' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="isService"
      label="Тип"
      width="100px"
      filterable
      filter-type="select"
      filter-send-name="isService"
      :filter-props="{
        clearable:   true,
        placeholder: 'Все',
        options: [
          { id: true,  name: 'Услуга' },
          { id: false, name: 'Товар' },
        ],
      }"
      content-align="center"
    >
      <template #default="{ row }">
        {{ row.isService ? 'Услуга' : 'Товар' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="descriptionForSeller"
      label="Описание для поставщика"
      width="200px"
      content-align="left"
    >
      <template #default="{ row }">
        {{ row.descriptionForSeller || '--' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="responsible"
      width="200px"
      label="Ответственный"
      content-align="left"
      filterable
      filter-type="select"
      :filter-props="{
        clearable:      true,
        placeholder:    'Введите ФИО',
        optionIdentity: 'personId',
        searchFunction: searchResponsible,
      }"
    >
      <template #default="{ row }">
        {{ row.responsible?.name || '--' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridActionBarV2>
      <VButton theme="primary" @click="openCard()">
        Создать товар
      </VButton>
    </VDataGridActionBarV2>
  </VDataGridV2>
</template>

<script lang="ts">

import ProductsService 		from '@/domains/Products/ProductsService';
import DataGridLoader  		from '@/lib/components/VDataGridV2/DataGridLoader';
import PersonsService 		from "@/domains/Persons/PersonsService";
import Product from "@/domains/Products/Product";

export default defineComponent({
  name: 'ProductsRegistry',

  data() {
    return {
      ProductsService,
      dataLoader: new DataGridLoader(ProductsService.getListPaginatedForRegistry),
    };
  },

  methods: {
    async openCard(row?: Product): Promise<void> {
      if (await ProductsService.showCard(row?.id ?? null)) {
        this.dataLoader.refresh();
      }
    },

    async searchResponsible(pattern: string): Promise<any[]> {
      const persons = await PersonsService.searchPersons(pattern, this.$core.currentPartner?.id);
      return persons.map(person => ({
        personId: person.id,
        name:     person.name,
        id:       { id: person.id },
      }));
    }
  },
});
</script>
